import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { PlatformContextService } from '@shared/services/platform-context';
import { TUNNEL_REFERRER_QUERY_PARAM, TunnelReferrerService } from '@shared/services/tunnel-referrer';

/**
 * Captures the funnel referrer a link names (`?gtm=design`), then drops the parameter from the address before the
 * page is read, so that a copied link does not mark the person who receives it.
 */
export const tunnelReferrerGuard: CanActivateFn = (route, state) => {
  const value = route.queryParamMap.get(TUNNEL_REFERRER_QUERY_PARAM);
  if (value === null || inject(PlatformContextService).isServer()) return true;
  inject(TunnelReferrerService).capture(value);
  const url = inject(Router).parseUrl(state.url);
  const { [TUNNEL_REFERRER_QUERY_PARAM]: _referrer, ...queryParams } = url.queryParams;
  url.queryParams = queryParams;
  return new RedirectCommand(url, { replaceUrl: true });
};
